import { render } from "./MyPage.vue?vue&type=template&id=5dd97f18&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=js"
export * from "./MyPage.vue?vue&type=script&lang=js"

import "./MyPage.vue?vue&type=style&index=0&id=5dd97f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd97f18"]])

export default __exports__